/** HubSpot の企業管理者向けお問い合わせフォーム URL */
const CONTACT_FORM_URL = 'https://support.fukuri-app.jp/client/contact';

/**
 * HubSpot のお問い合わせフォームへの遷移 URL を組み立てる
 *
 * CS 側がどのパートナー経由の問い合わせかを識別できるよう、ログイン中の
 * パートナーコード（three letter code）を `tlc` パラメーターとして付与する。
 * Cookie 未設定などでパートナーコードが取得できない場合はパラメーターを付けず、
 * フォーム自体には遷移できる状態を保つ。
 *
 * @param threeLetterCode - ログイン中のパートナーコード
 */
export const buildContactFormUrl = (threeLetterCode: string | undefined): string =>
  threeLetterCode
    ? `${CONTACT_FORM_URL}?tlc=${encodeURIComponent(threeLetterCode)}`
    : CONTACT_FORM_URL;
